import { createActions, createReducer } from 'reduxsauce'
import _ from 'lodash'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  dynamicFeeLoading: false,
  addingDynamicFee: false,
  dynamicFees: {},
})

const { Types, Creators } = createActions({
  setDynamicFees: ['dynamicFees'],
  setDynamicFee: ['dynamicFeeId', 'data'],
  setDynamicFeeAdding: ['val'],
  setDynamicFeeLoading: ['val'],

  saveDynamicFee: ['data', 'callBack'],
  deleteDynamicFee: ['feeKey'],
  syncDynamicFees: null,
})

export const setDynamicFeeReducer = (state, { dynamicFeeId, data }) =>
  state.setIn(
    ['dynamicFees', dynamicFeeId],
    state.dynamicFees[dynamicFeeId]
      ? { ...state.dynamicFees[dynamicFeeId], ...data, key: dynamicFeeId }
      : { ...data, key: dynamicFeeId }
  )

export const deleteDynamicFeeReducer = (state, { feeKey }) =>
  state.set('dynamicFees', _.omit(state.dynamicFees, feeKey))

export const setDynamicFeesReducer = (state, { dynamicFees }) =>
  state.set('dynamicFees', dynamicFees).set('dynamicFeeLoaded', true)

export const setDynamicFeeAddingReducer = (state, { val }) => state.set('addingDynamicFee', val)

export const setDynamicFeeLoadingReducer = (state, { val }) => state.set('dynamicFeeLoading', val)

export const dynamicFeeReducer = createReducer(INITIAL_STATE, {
  [Types.SET_DYNAMIC_FEES]: setDynamicFeesReducer,
  [Types.SET_DYNAMIC_FEE]: setDynamicFeeReducer,
  [Types.SET_DYNAMIC_FEE_LOADING]: setDynamicFeeLoadingReducer,
  [Types.SET_DYNAMIC_FEE_ADDING]: setDynamicFeeAddingReducer,
  [Types.DELETE_DYNAMIC_FEE]: deleteDynamicFeeReducer,
})

export const DynamicFeeTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/dynamicFeeReducer.js